import React, { createElement } from 'react';
import { formatImage } from '@ifeng/public_method';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import Chip from 'Chip';

export interface NewsList_10_Props {
    nodeId?: string
    style?: object;
    newsChip: TYPE_Chip;
    grid: {
        templateAreas: string
        templateRows: (string|number)[]
        templateColumns: (string|number)[]
    };

    cellWidth: number;
    cellHeight: number;
    gap: number;
}

const NewsList_10: React.FC<NewsList_10_Props> = (props) => {
    const { nodeId, newsChip, style, grid: { templateAreas, templateColumns, templateRows }, cellWidth, cellHeight, gap, textStyle } = props;

    const content = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    const formatRowsAndColumns = (valueArr, cell) => {
        let res = ''
        for (const value of valueArr) {
            if (typeof value === 'number') {
                if (cell) {
                    res += `${value * cell + gap * (value - 1)}px `
                } else {
                    res += `${value}fr `
                }
            } else {
                res += `${value} `
            }
        }
        return res.trim()
    }

    return content.length ? (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.wrap} style={{ gridTemplateAreas: templateAreas, gridTemplateRows: formatRowsAndColumns(templateRows, cellHeight), gridTemplateColumns: formatRowsAndColumns(templateColumns, cellWidth), gridGap: `${gap}px`, ...style }}>
                {
                    Array.from(new Set(templateAreas.split(/\s/g).map(a => a.replace(`"`, '')))).map((a, b) => {
                        return (
                            <div key={b} className={moduleCss.gridChildren} style={{ gridArea: a }}>
                                {
                                    content[b] &&
                                    <React.Fragment>
                                        <img
                                            src={formatImage(getThumbnailFromRecommend(content[b]))}
                                            alt=""
                                            className={moduleCss.itemImg}
                                        />
                                        <div className={moduleCss.mask}>
                                            <a href={content[b].url} target="_blank">
                                                <div className={moduleCss.maskText}>
                                                    <div>{content[b].title}</div>
                                                </div>
                                            </a>
                                        </div>
                                    </React.Fragment>
                                }

                            </div>
                        )
                    })
                }
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    ) : null;
};

export default NewsList_10;
